import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import ExternalLink from 'components/Widgets/ExternalLink';
import IconWithText from 'components/Widgets/IconWithText';

import Archive from './Archive';

export default function Index() {
  const [growthReports, setGrowthReports] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.growth_reports.index)
      .then((response) => {
        setGrowthReports(response.data.data);
      });
  }, []);

  return (
    <section>
      <h4 className="mb-4">Growth Report</h4>

      <Row>
        <Col sm={9} lg={10}>
          <IconWithText
            iconClassName="certified-icon big-icon bg-secondary"
            contentClassName="mb-3 mb-sm-0"
            wrapperClassName="align-items-start"
          >
            <>
              <p>
                The Growth Report provides a comprehensive view of your development attained during the
                {' '}
                coaching engagement, indicating your positive growth and increased awareness across all
                {' '}
                twelve dimensions of Productivity and Wellbeing.
              </p>

              {growthReports === null ? (
                <LoadingPlaceholder />
              ) : (
                <Archive growthReports={growthReports} />
              )}
            </>
          </IconWithText>
        </Col>

        <Col sm={3} lg={2}>
          <a
            href={routes.members.growthReport.show}
            className={`
              btn btn-primary d-sm-block px-3 px-sm-0 mb-3 me-3 me-sm-0 ${growthReports?.length > 0 ? '' : 'disabled'}
            `}
          >
            View
          </a>

          <ExternalLink
            href={(growthReports?.length > 0 && growthReports[0].attributes.url) || ''}
            variant="outline-primary"
            className={`
              btn-reverse d-sm-block px-3 px-sm-0 mb-3 mb-sm-0 ${growthReports?.length > 0 ? '' : 'disabled'}
            `}
          >
            Report
          </ExternalLink>
        </Col>
      </Row>
    </section>
  );
}
